module.exports = __webpack_public_path__ + "ath_game_web/img/5.6.d4633411.png";